const dataLayer = window.dataLayer || [];

window.addEventListener('newsletterSubscription', () => {
    dataLayer.push({
        'event': 'newsletter subscription'
    });
});
